import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationStateService } from 'src/app/services/notification-state.service';
// Importe seu serviço de modal, ex: NgbModal, MatDialog, ou um serviço customizado
import { NotificationPanelComponent } from '../notification-panel/notification-panel.component';

@Component({
  selector: 'app-notification-bell',
  templateUrl: './notification-bell.component.html',
  styleUrls: ['./notification-bell.component.scss'],
})
export class NotificationBellComponent implements OnInit {
  unreadCount$: Observable<number>;

  constructor(
    private notificationStateService: NotificationStateService,
    // private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.unreadCount$ = this.notificationStateService.unreadCount$.asObservable();
  }

  openNotificationModal() {
    // Lógica para abrir o modal. Exemplo com NgbModal:
    // this.modalService.open(NotificationModalComponent, { size: 'lg', centered: true });
  }
}
